// extracted by mini-css-extract-plugin
export default {"leftSideWrapper":"_0Ts3C","center":"cKq8M","backBtn":"yDOIw"};